import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../../configs';
import processError from '../../../../utils/processError';
import { rejectActionPromise } from '../../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../../utils/resolveActionPromise';
import { createBlackWhitesFailed, createBlackWhitesSuccessful } from '../../actions';
import makeRequest from '../../../../utils/makeRequest';
import { CREATED } from '../../../../configs/serverStatusCodes';

export default function* createBlackWhites(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      yield put(createBlackWhitesSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(createBlackWhitesFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createBlackWhitesFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
